<script>
	import InfoPage from './InfoPage.svelte';
	import InfoSection from './InfoSection.svelte';
	import { Icon } from '../feathericons.js';

</script>

<InfoPage Title="Melbourn">

<svelte:fragment slot="blurb">
<InfoSection src="pics/mel.jpg" alt="Melbourn">
<p>Melbourn is a wonderful village on the border between Hertfordshire and Cambridgeshire. It has a couple of parks, pubs, and shops, a pharmacy, and a nice restaurant. Melbourn also has a number of walks that link to neighbouring villages.</p>
<p><a href="http://melbourncambridge.org/village-information/" target="new">{@html Icon("external-link","small")} Melbourn website</a></p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="walks">
<InfoSection id="stockbridge_meadows" Title="Stockbridge Meadows" src="pics/mel-stock.jpg" alt="Stockbridge Meadows">
<p>Stockbridge meadows is a tiny nature reserve just off the delightfully named Dolphin Lane (I am not sure if the pub was named after the lane or the lane after the pub!), it features a few paths, some sculptures, and access to the river Mel. It has free parking and is normally very quiet.</p>
</InfoSection>
<InfoSection id="the_moor" Title="The Moor" src="pics/mel-moor.jpg" alt="The Moor">
<p>The moor consist of two large fields that back on to the river Mel. It has a fairly large free car pack, picnic benches, a little apple orchard, and sits behind Melbourn’s leisure centre. The Moor is also the start of a nice walk that will take you into Meldreth; just walk through the orchard, away from the moor and follow the path. Once you cross the train line (I tend to go under rather than over) you can access Melwood and into the cow fields.</p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="playgrounds">
<InfoSection id="melbourn_enclosed_playground" Title="Melbourn Enclosed Playground" src="pics/mel-park-1.jpg" alt="Melbourn Enclosed Playground">
<p>
This playground is found in a small estate off just off new road. It features an enclosed space with a little kid section to one side. It has a good selection of activities and picnic benches. </p>
</InfoSection>
<InfoSection id="melbourn_fields_playground" Title="Melbourn Moor Playground" src="pics/mel-park-2-1.jpg" alt="Melbourn Moor Playground">
<p>This playground makes up part of the moor. It is mostly enclosed, although often the gate to the moor is left open. It has a mix of big and little kid activities and is often fairly busy.</p>
</InfoSection>
</svelte:fragment>


<svelte:fragment slot="noteworthy">
<table class="u-fill-width">
<thead>
<tr>
	<th>Place</th>
	<th>Note</th>
	<th>Link</th>
</tr>
</thead>
<tbody>
<tr>
<td>The Dolphin</td>
<td>A fairly cheap Greenking pub that servers food.</td>
<td><a href="https://www.greeneking-pubs.co.uk/pubs/hertfordshire/dolphin/?utm_source=g_places&utm_medium=locations&utm_campaign=">Greenking</a></td>
</tr>
<tr>
<td>The Black Horse</td>
<td>A small pub</td>
<td><a href="https://www.theblackhorsemelbourn.co.uk/">www.theblackhorsemelbourn.co.uk</a></td>
</tr>
<tr>
<td>Sheen Mill</td>
<td>An upmarket restaurant and wedding venue. The food is pretty good but similar quality can be found for less else where.</td>
<td><a href="https://sheenemill.com">sheenemill.com</a></td>
</tr>
</tbody>
</table>
</svelte:fragment>


</InfoPage>
<!--
Need to add
restaurant
2 pubs
bury lane
sport centre
-->
